import * as Yup from 'yup';

export const discountOrderGlobalSchema = Yup.object().shape({
  percentage: Yup.number().max(100).min(0).required(),
});
